import { contactActions } from '@/store/modules/head/dep/head_pc_six_json.js'
import { shareActions } from '@/store/modules/product_intro_json.js'
import { btnFlags, types } from '@/components/widgets/product_intro/element.js'
import { getNodeByFlag } from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import { language } from '@/consts/language.js'

export const washListCert = (node, flag, property = 'flag') => {
  const findJson = getNodeByFlag(node, flag, property)
  if (!findJson) return
  if (flag === 'divContainer') {
    if(!findJson.flag) findJson.flag = 'content-container'
    findJson.data.design.self_height = { diannao: 100, pingban: 100, shouji: 100 }
    findJson.data.design.self_heightUnit = { diannao: '%',  pingban: '%', shouji: '%' }
  } else if(flag === 'cert-list-img') {
    if(!findJson.imgStyle) findJson.imgStyle = { 'object-fit': 'contain', display: 'block' }
  }
}
export const washDetail = (node, flag, property = 'flag', isMobile = false) => {
  let contentFlag = ''
  let shareFlag = ''
  if(flag === 'case') {
    contentFlag = 'case-detail-content'
    shareFlag = 'case-detail-share-text'
  } else if(flag === 'news') {
    contentFlag = 'news-detail-content'
    shareFlag = 'news-detail-share-text'
  }
  const findJson = getNodeByFlag(node, contentFlag, property)
  findJson.data.hover.title_hoverColor = { diannao: '', pingban: '', shouji: ''}
  const shareJson = getNodeByFlag(node, shareFlag)
  if(shareJson) {
    shareJson.actions = [...shareJson.actions, 'isShow']
  }
}
export const washFourDetail = (node, flag, property = 'flag')=> {
  const findJson = getNodeByFlag(node, flag, property)
  if(!findJson) return
  const prevIcon = findJson.list[0].list[0]
  prevIcon._icon = "&#xe730;"
  prevIcon.data.design.self_icon ="&#xe730;"
  const nextIcon = findJson.list[1].list[0]
  nextIcon._icon = "&#xe731;"
  nextIcon.data.design.self_icon ="&#xe731;"
  if(flag === 'case-detail-par') {
    prevIcon.flag = 'case-detail-previous-icon'
    nextIcon.flag = 'case-detail-next-icon'
  } else if(flag === 'news-detail-par') {
    prevIcon.flag = 'news-detail-previous-icon'
    nextIcon.flag = 'news-detail-next-icon'
  }
}
export const washHeadData = (node, flag, property = 'flag', isMobile = false) => {
  const pcNode = node.list[0] || {}
  const mobileNode = node.list[1] || {}
  if (JSON.stringify(pcNode) !== '{}') dealPcHeadData(pcNode, flag, property)
  if (JSON.stringify(mobileNode) !== '{}' && isMobile) dealMobileHeadData(mobileNode, flag, property, isMobile)
}
const dealPcHeadData = (node, flag, property) => {
  const pcHeadJson = property === 'rNav' || flag === 'mid-row' || flag === 'eleven-logo' || flag === 'search' || flag === 'e-Nav' ? node : getNodeByFlag(node, flag, property)
  if (!pcHeadJson) return
  if (property === '_contentType') {
    dealHeadContact(node, flag, property)
  } else if (property === 'rNav') {
    dealHeadNav(node, flag)
  } else if (flag === 'language_flagNameSelect') {
    dealHeadLanguage(node, flag, property)
  } else if (flag === 'card') {
    dealCard(node, flag, property)
  } else if(flag === 'mid-row'){
    dealHeadRowCol(node)
  } else if(flag === 'eleven-logo') {
    dealElevenLogo(node, false)
  } else if(flag === 'search') {
    dealSearch(node)
  } else if(flag === 'rowCol') {
    dealNineCard(node)
  }else if(flag === 'e-Nav') {
    dealENav(node)
  }else {
    dealHeadJson(node, flag, property)
  }
}
const dealENav = (node)=> {
  const findJson = getNodeByFlag(node, 'headNav', 'flag')
  if(!findJson) return
  findJson._isHideFirstTextBorder = false
}
const dealNineCard = (node)=> {
  if(!node || !node.list[0]) return
  node.list[0].data.hover.self_hoverBackgroundColor = {diannao: '', pingban: '', shouji: ''}
}
const dealSearch = (node)=> {
  const findJson = getNodeByFlag(node, 'search', 'componentName')
  if(!findJson) return
  if(findJson.actions) {
    if(!findJson.actions.includes('isShow')) {
      findJson.actions.push('isShow')
    }
  }
}
const dealElevenLogo = (node, isMobile = false)=> {
  const findJson = getNodeByFlag(node, 'logo', 'name')
  if(!findJson) return
  if(isMobile) {
    findJson._maxImgHeightMax = 100
  } else {
    findJson._maxSelfHeightMax = 200
  }
  if(findJson.actions) {
    for (let i in findJson.actions) {
      if (findJson.actions[i].name === 'design') {
        const designConfig =
          findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]] || []
        if (!designConfig.includes(isMobile ? 'img_height' : 'self_height')) {
          findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]].push(
            isMobile ? 'img_height' : 'self_height'
          )
        }
        break
      }
    }
  }
}
const dealHeadRowCol = (node)=> {
  const leftCol = getNodeByFlag(node?.list[1], 20, '_width')
  const midCol = getNodeByFlag(node?.list[1], 65, '_width')
  const rightCol = getNodeByFlag(node?.list[1], 15, '_width')
  if(leftCol && midCol && rightCol) {
    leftCol._width = 20
    leftCol.data.design.self_width = { diannao: '20', pingban: '20', shouji: '20' }
    leftCol.data.self_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
    midCol._width = 60
    midCol.data.design.self_width = { diannao: '60', pingban: '60', shouji: '60' }
    midCol.data.self_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
    rightCol._width = 20
    rightCol.data.design.self_width = { diannao: '20', pingban: '20', shouji: '20' }
    rightCol.data.self_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
  }
}
const dealCard = (node, flag, property)=> {
  const findJson = getNodeByFlag(node, flag, property)
  if(!findJson) return
  for (let i in findJson.actions) {
    if (findJson.actions[i].name === 'design') {
      const designConfig = findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]] || []
      if (!designConfig.includes('4')) findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]].push('4')
      break
    }
  }
}

const dealHeadLanguage = (node, flag, property)=> {
  const languageNode = getNodeByFlag(node, flag, property)
  if(!languageNode) return
  const { design } = languageNode.data
  const newDesign = {}
  Object.keys(design).forEach(key => {
    if(key.startsWith('self_borderRadius')) {
      const newKey = key.replace('self_borderRadius', 'boxHeight_borderRadius')
      newDesign[newKey] = design[key]
    } else if (key.startsWith('self_background')) {
      const newKey = key.replace('self_background', 'boxHeight_background')
      newDesign[newKey] = design[key]
    } else {
      newDesign[key] = design[key]
    }
  })
  languageNode.data.design = newDesign
  if(languageNode.actions !== undefined) {
    if(!languageNode.actions.includes('attribute')) {
      languageNode.actions = ['attribute', ...languageNode.actions]
    }
  }
}
const dealHeadNav = (node, flag) => {
  try {
    switch (flag) {
      case 'head_style_one':
        dealOne(node)
        break
      case 'head_style_two':
        dealOne(node)
        break
      case 'head_style_three':
        dealThree(node)
        break
      case 'head_style_four':
        dealNav(node.list[1])
        break
      case 'head_style_five':
        dealNav(node.list[0])
        break
      case 'head_style_six':
        // 不具备条件
        break
      case 'head_style_seven':
        // 不具备条件 7写个新的（12），导航行高变成40，行高放出来，搜索变成按钮的样式
        break
      case 'head_style_eight':
        break
      case 'head_style_nine':
        dealNine(node)
        break
      case 'head_style_ten':
        dealNine(node)
        break
      case 'head_style_eleven':
        dealEleven(node)
        break
      default:
        break
    }
  } catch (err){}
}
const dealEleven = (node)=> {
  dealNav(node)
  if (node.list[2].list[0].list[0].componentName === 'col') {
    node.list[2].list[0].list[0].data.design.selfStyle_radioValue = 1
  }
}
const dealNine = (node)=> {
  dealNavTwo(node)
  if (node.list[1].list[0].list[0].componentName === 'col') {
    node.list[1].list[0].list[0].data.design.selfStyle_radioValue = 1
  }
  if (node.list[1].list[0].list[1].componentName === 'col') {
    node.list[1].list[0].list[1].data.design.selfStyle_radioValue = 1
  }
}
const dealThree = (node)=> {
  dealNav(node.list[1])
}
const dealNav = (node)=> {
  const navJson = getNodeByFlag(node,'nav', 'componentName')
  if(!navJson) return
  navJson._isHideFirstLineHeight = false
}
const dealNavTwo = (node)=> {
  const navJson = getNodeByFlag(node,'nav', 'componentName')
  if(!navJson) return
  navJson._isHideFirstLineHeight = false
  if (navJson.data.design.elementFirstNavItem_lineHeight.diannao === 90) {
    navJson.data.design.elementFirstNavItem_lineHeight.diannao = 40
  }
}
const dealOne = (node)=> {
  if (node.list[1].list[0].list[0].componentName === 'col') {
     node.list[1].list[0].list[0].data.design.selfStyle_radioValue = 1
  }
  if (node.list[1].list[0].list[1].componentName === 'col') {
    node.list[1].list[0].list[1].data.design.selfStyle_radioValue = 1
    const navJson = getNodeByFlag(node.list[1], 'nav', 'componentName')
    navJson._isHideFirstLineHeight = false
    if (navJson.data.design.elementFirstNavItem_lineHeight.diannao === 90) {
      navJson.data.design.elementFirstNavItem_lineHeight.diannao = 40
    }
  }
  if (node.list[1].list[0].list[2].componentName === 'col') {
    node.list[1].list[0].list[2].data.design.selfStyle_radioValue = 1
    const searchJson = getNodeByFlag(node.list[1], 'search', 'componentName')
    searchJson.data.design.self_marginTop = { diannao: 0, pingban: 0, shouji: 0 }
  }
}
const dealMobileHeadData = (node, flag, property) => {
  const mobileHeadJson = flag === 'eleven-logo' ? node : getNodeByFlag(node, flag, property)
  if (!mobileHeadJson) return
  if(flag === 'eleven-logo') {
    dealElevenLogo(node, true)
  } else {
    dealHeadJson(node, flag, property)
    dealMobileCard(node, 'rowColFlag', property)
   if(flag === 'language_flagNameSelect') dealHeadLanguage(node, flag, property)
    if(flag === 'logo') dealMobileLogo(node, flag, property)
  }
}
const dealMobileLogo = (node, flag, property)=> {
  const logoJson = getNodeByFlag(node, flag, property)
  if(!logoJson || logoJson.componentName === 'image_image2') return
  logoJson.imgBoxStyle = { 'object-fit': 'contain', 'aspect-ratio': 168 / 50 }
  logoJson.imgStyle = { 'object-fit': 'contain', 'aspect-ratio': 168 / 50 }
  if(logoJson?.data?.design?.img_height?.shouji === 50) {
    logoJson.data.design.img_height.shouji = 'auto'
    logoJson.data.design.img_heightUnit.shouji = ''
  }
  if(logoJson?.data?.design?.img_height?.pingban === 50) {
    logoJson.data.design.img_height.pingban = 'auto'
    logoJson.data.design.img_heightUnit.pingban = ''
  }
}
function dealMobileCard(node, flag, property) {
  const cardJson = getNodeByFlag(node, flag)
  if(!cardJson) return
  cardJson.data.attribute.self_text = ''
  if(node.list[0].list[1].flag === 'rowColFlag') node.list[0].list[1].data.attribute.self_text = ''
}
function dealHeadContact(node, flag, property) {
  const findJson = getNodeByFlag(node, flag, property)
  if(!findJson) return
  findJson.actions = contactActions
}
function dealHeadJson(node, flag, property, isMobile = false) {
  const findJson = getNodeByFlag(node, flag, property)
  if(!findJson) return
  if(flag === 'logo') {
    if(isMobile) {
      if(!findJson.flag) findJson.flag = 'mobile-logo'
    } else {
      if(!findJson.flag) findJson.flag = 'pc-logo'
      if(findJson.data?.design?.img_width && findJson.data?.design?.img_width.diannao === 'auto') {
        findJson.data.design.img_width.diannao = 100
        findJson.data.design.img_widthUnit.diannao = '%'
      }
    }
  }
  if (!findJson.actions || findJson.actions.length === 0) {
    switch (flag) {
      case 'logo':
        findJson.actions = [
          'attribute',
          {
            name: 'design',
            config: {
              分组: ['self_borderRadius', 'self_background']
            }
          },
          'link',
          'translate',
          'isShow'
        ]
        break
      case 'head-title':
        findJson.actions = [
          'edit',
          'design',
          {
            name: 'hover',
            groupLayout: 'topBottom',
            config: {
              分组: ['self_background', 'title_fontSize', 'title_color', 'title_textStyle']
            }
          },
          'translate',
          'isShow'
        ]
        break
      case 'home_product_title':
        findJson.actions = [
          'edit',
          'design',
          {
            name: 'hover',
            groupLayout: 'topBottom',
            config: {
              分组: ['self_background', 'title_fontSize', 'title_color', 'title_textStyle']
            }
          },
          'translate',
          'isShow'
        ]
        break
    }
  } else {
    const isHaveDesignStr = findJson.actions.includes('design')
    const isHaveTransLateStr = findJson.actions.includes('translate')
    const isHavIsShow = findJson.actions.includes('isShow')
    if (flag === 'logo') {
      if (!isHaveDesignStr) {
        let isHaveDesignObj = false
        for (let i in findJson.actions) {
          if (findJson.actions[i].name === 'design') {
            isHaveDesignObj = true
            const designConfig =
              findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]] || []
            if (!designConfig.includes('self_background')) {
              findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]].push(
                'self_background'
              )
            }
            break
          }
        }
        if (!isHaveDesignObj) {
          findJson.actions.unshift('design')
        }
      }
      if (!isHavIsShow) {
        findJson.actions.push('isShow')
      }
    }
    if (!isHaveTransLateStr) {
      findJson.actions.push('translate')
    }
    if (!isHavIsShow) {
      findJson.actions.push('isShow')
    }
  }
}
export const washText = (node) => {
  const title = getNodeByFlag(node, 'product-title')
  const intro = getNodeByFlag(node, 'product-intro')
  if (title) {
    title._isShowLineClamp = true
    title.data.design.title_lineClamp = { diannao: 'unset', pingban: 'unset', shouji: 'unset' }
    title.data.design.self_height = { diannao: 'auto', pingban: 'auto', shouji: 'auto' }
    title.data.design.self_height_unit = { diannao: '',  pingban: '', shouji: '' }
  }
  if (intro) {
    intro._isShowLineClamp = true
    intro.data.design.title_lineClamp = { diannao: 'unset', pingban: 'unset', shouji: 'unset' }
    intro.data.design.self_height = { diannao: 'auto', pingban: 'auto', shouji: 'auto' }
    intro.data.design.self_height_unit = { diannao: '',  pingban: '', shouji: '' }
  }
}
export const washShareData = (node, flag, property = 'flag') => {
  const shareJson = getNodeByFlag(node, flag, property)
  if (!shareJson) return
  shareJson.flag= 'product-intro-share'
  shareJson.actions = shareActions
  shareJson.data.edit = '{{share}}'
}
export const washNumButton = (node, flag, property = 'flag', type = '')=> {
  const findJson = getNodeByFlag(node, flag, property)
  if (!findJson) return
  washDesignNumData(findJson, flag)
}
const washDesignNumData = (node)=> {
  if (!node.actions) return
  try {
    if(!node.actions[0].config['按钮设计'].includes('self_width')) node.actions[0].config['按钮设计'].unshift('self_width')
    if(!node._selfWidthMin) node._selfWidthMin = 1
    if(!node._selfWidthMax) node._selfWidthMax = 150
  } catch (err) {}
}
export const washLanguageData = (node, flag, property = 'flag', type = '') => {
  const btnJson = getNodeByFlag(node, flag, property)
  if (!btnJson) return
  washActionsData(btnJson, flag, property)
  washDesignData(btnJson, flag)
  washSyncComponentData(btnJson, flag, type)
}
export const washListItem = (node) => {
  const listItem = getNodeByFlag(node, 'mz-swiper-slide', 'className')
  if (!listItem) return
  if(!listItem.list[0].flag) listItem.list[0].flag = 'home-product-slide-list-card'
  washProductListItem(node,  'home-product-slide-list-card')
}
export const washProTwoBtn = (node)=> {
  const findJson = getNodeByFlag(node, 'product-cate-list-btn')
  if (!findJson) return
  findJson._borderColor = findJson._borderColor ?? ''
  findJson._borderWidth = findJson._borderWidth ?? 0
}
export const washImg = (node, flag, property = 'flag', type = '')=> {
  const imgJson = getNodeByFlag(node, 'home-product-img', property)
  const { design } = imgJson.data
  if (!design.img_height.diannao && !design.img_height.pingban && !design.img_height.shouji) {
    design.img_height = { diannao: 100, pingban: 100, shouji: 100 }
    design.img_heightUnit = { diannao: '%', pingban: '%', shouji: '%' }
  }
}
export const washProductFour = (node) => {
  washFourTitle(node)
  washProductListItem(node, 'home-product-slide-list-card')
  washHoverBox(node)
}
const washHoverBox = (node)=> {
  const findJson = getNodeByFlag(node, 'hover-mask')
  if(!findJson) return
  findJson.data.design.self_backgroundColor = { diannao: 'var(--mask-background)',pingban: 'var(--mask-background)',shouji: 'var(--mask-background)' }
}
export const washProductListItem = (node, flag, paddingName = '2')=> {
  const findJson = getNodeByFlag(node, flag)
  if(!findJson || !findJson.actions) return
  for (let i in findJson.actions) {
    if (findJson.actions[i].name === 'design') {
      if(!findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]]?.includes(paddingName)) {
        findJson.actions[i].config[Object.keys(findJson.actions[i].config)[0]].push(paddingName)
      }
      break
    }
  }
}
export const washProductThree = (node) => {
  const findJson = getNodeByFlag(node, 'home-product-title')
  if(!findJson) return
  findJson.borderIsHide ??= false
  findJson.actions?.find((a)=> {
    if(a.name !== 'hover') return false
    const firstConfigKey = Object.keys(a.config).at(0)
    if(firstConfigKey) {
      const configArray = a.config[firstConfigKey]
      a.config[firstConfigKey] = [...new Set([...configArray, 'self_border'])]
    }
    return true
  })
}
const washFourTitle = (node)=> {
  const findJson = getNodeByFlag(node, 'home-product-title')
  if(!findJson) return
  if( !Object.hasOwn(findJson, 'borderIsHide')) {
    findJson.borderIsHide = false
  }
  const { self_marginBottom, self_marginTop, self_marginLeft, self_marginRight, self_marginUnit } = findJson.data.design
  findJson.data.design.self_paddingBottom = self_marginBottom
  findJson.data.design.self_paddingTop = self_marginTop
  findJson.data.design.self_paddingLeft = self_marginLeft
  findJson.data.design.self_paddingRight = self_marginRight
  findJson.data.design.self_paddingUnit = self_marginUnit
  findJson.data.design.self_marginBottom = { diannao: 0, pingban: 0, shouji: 0 }
  findJson.data.design.self_marginTop = { diannao: 0, pingban: 0, shouji: 0 }
  findJson.data.design.self_marginLeft = { diannao: 0, pingban: 0, shouji: 0 }
  findJson.data.design.self_marginRight = { diannao: 0, pingban: 0, shouji: 0 }
  findJson.data.design.self_marginUnit = { diannao: 'px', pingban: 'px', shouji: 'px' }
}
const washSyncComponentData = (btnJson, flag, type) => {
  if (type !== types.one && type !== types.two) return
  if (type === types.one) {
    if (flag === btnFlags.inquireNow) {
      btnJson.synchNodes = {
        exclude: ['self_textInput'],
        nodeFlags: [btnFlags.nextProduct, btnFlags.addToCart]
      }
      btnJson.disabled = false
    } else if (flag === btnFlags.nextProduct) {
      btnJson.synchNodes = {
        exclude: ['self_textInput'],
        nodeFlags: [btnFlags.inquireNow, btnFlags.addToCart]
      }
      btnJson.disabled = false
    }
  } else if (type === types.two) {
    switch (flag) {
      case btnFlags.inquireNow:
        btnJson.synchNodes = {
          exclude: ['self_textInput'],
          nodeFlags: [btnFlags.nextProduct, btnFlags.addToCart, btnFlags.downloadSingle]
        }
        btnJson.disabled = false
        break
      case btnFlags.nextProduct:
        btnJson.synchNodes = {
          exclude: ['self_textInput'],
          nodeFlags: [btnFlags.inquireNow, btnFlags.addToCart, btnFlags.downloadSingle]
        }
        btnJson.disabled = false
        break
      case btnFlags.downloadSingle:
        btnJson.synchNodes = {
          exclude: ['self_textInput'],
          nodeFlags: [btnFlags.inquireNow, btnFlags.nextProduct, btnFlags.addToCart]
        }
        btnJson.disabled = false
        break
    }
  }
}
const washDesignData = (btnJson, flag) => {
  try {
    let { self_text = '' } = btnJson.data.attribute
    if (self_text) {
      if (self_text.includes('+')) {
        self_text = self_text.replace('+', '')
        self_text = self_text.trim()
        btnJson.data.design.self_text = self_text
      } else {
        if (language[flag]) {
          btnJson.data.design.self_text = language[flag]
        } else {
          btnJson.data.design.self_text = self_text
        }
      }
      btnJson.data.attribute.self_text = ''
      btnJson.cacheKey = Date.now()
    } else {
      if (language[flag]) {
        btnJson.data.design.self_text = language[flag]
      } else {
        btnJson.data.design.self_text = self_text
      }
    }
  } catch (error) {
    console.log('washDesignData error', error)
  }
}
const washActionsData = (btnJson) => {
  if (!btnJson.actions || btnJson.actions.length === 0) {
    btnJson.actions = ['design', 'hover', 'translate']
  } else {
    const isHaveDesignStr = btnJson.actions.includes('design')
    const isHaveAttribute = btnJson.actions.includes('attribute')
    if (!isHaveDesignStr) {
      let isHaveDesignObj = false
      for (let i in btnJson.actions) {
        if (btnJson.actions[i].name === 'design') {
          isHaveDesignObj = true
          btnJson.actions[i].config[Object.keys(btnJson.actions[i].config)[0]].unshift(
            'self_textInput'
          )
          break
        }
      }
      if (!isHaveDesignObj) {
        if (isHaveAttribute) {
          btnJson.actions.splice(1, 0, 'design')
        } else {
          btnJson.actions.unshift('design')
        }
      }
    }
    btnJson._contentIsHide = false
    const isHaveTranslate = btnJson.actions.includes('translate')
    if (!isHaveTranslate) {
      btnJson.actions.push('translate')
    }
  }
}
export const washNesTabOne = (node)=> {
  if(!node) return
  node.data.design.leftStyle_width = { diannao: 40, pingban: 40, shouji: 100 }
  node.data.design.leftStyle_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
}
export const washNesTabTwo = (node) => {
  const findJson = getNodeByFlag(node,'news-tab-img')
  if(!findJson) return
  findJson.isHideParentBox = true
  findJson.data.design.self_width = { diannao: 50, pingban: 100, shouji: 100 }
  findJson.data.design.self_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
}
export const washNesTabThree = (node)=> {
  const findJson = getNodeByFlag(node,'news-tab-img')
  if(!findJson) return
  findJson.data.design.self_width = { diannao: 50, pingban: 40, shouji: 45 }
  findJson.data.design.self_widthUnit = { diannao: '%', pingban: '%', shouji: '%' }
  findJson.data.design.self_maxWidth = { diannao: '', pingban: '', shouji: '' }
  findJson.data.design.self_maxWidthUnit= { diannao: '', pingban: '', shouji: '' }
}
export const washImageFor11 = (node)=> {
  const findJson = getNodeByFlag(node,'w11-img')
  if(!findJson) return
  delete findJson.imgStyle['aspect-ratio']
}
export const washCC = (node)=> {
  const findJson = getNodeByFlag(node,'w11-content-container')
  if(!findJson) return
  findJson.data.design.self_paddingTop = { diannao: 0, pingban: 0, shouji: 0 }
  findJson.data.design.self_paddingBottom = { diannao: 0, pingban: 0, shouji: 0 }

}
export const wash11Cart = (node)=> {
  const findJson = getNodeByFlag(node,'w11-paging-right-btn')
  if(!findJson) return
  findJson._contentIsHide = true
  findJson.actions = ['design', 'hover']
}
